import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=1183eb86&scoped=true&"
import script from "./newIndex.vue?vue&type=script&lang=ts&"
export * from "./newIndex.vue?vue&type=script&lang=ts&"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=1183eb86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1183eb86",
  null
  
)

export default component.exports